import React, { useState } from 'react';
import PropTypes from 'prop-types';

const ShowMore = ({ children }) => {
    const [open, setOpen] = useState(false);

    const showMore = children.length > 3;
    const numberOfShownChildren = open ? children.length : 3;
    const numberOfRemainingChildren = children.length - 3;

    return (
        <div>
            {children.slice(0, numberOfShownChildren)}
            {showMore && (
                <button
                    type="button"
                    className="button button--utility button--small min-w-full"
                    onClick={() => {
                        setOpen(!open);
                    }}
                >
                    {open ? 'Vis mindre' : `Vis flere (${numberOfRemainingChildren})`}
                </button>
            )}
        </div>
    );
};

ShowMore.propTypes = {
    children: PropTypes.node,
};

export default ShowMore;
